import { connect } from 'react-redux';

import { reportUpdateComment } from 'actions/property-explorer';
import { saveReport } from 'actions/edit-report';

import { getIsReportSaveable } from 'selectors/report-permissions';
import { getReportComments } from 'selectors/property-explorer';
import {
  getReportStatusUserVersionIsLoadedInitial,
  getReportStatusIsRecomputing,
  getReportStatusHcVersionIsLoadedInitial
} from 'selectors/report-status';

import PropertyExplorerComments from 'legacy/components/PropertyExplorerComments';

const mapStateToProps = (state, ownProps) => {
  return {
    commentValue: getReportComments(state),
    readOnly:
      !getIsReportSaveable(state) || getReportStatusIsRecomputing(state),
    hasLoaded:
      getReportStatusUserVersionIsLoadedInitial(state) &&
      getReportStatusHcVersionIsLoadedInitial(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSave: (value) => {
    dispatch(reportUpdateComment(value));
    dispatch(saveReport());
    ownProps.onClose();
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyExplorerComments);
